export const reportHeaderSx = {
  background: "linear-gradient(120deg, #123149, #155e66)",
  color: "#fff",
  p: { xs: 2, sm: 2.5 },
  "& .MuiTypography-root": { color: "#fff !important" },
  "& .MuiSvgIcon-root": { color: "#fff !important" },
  "& .MuiIconButton-root": {
    color: "#fff !important",
    width: 32,
    height: 32,
    borderColor: "#ffffff40",
  },
};
export const reportPaperSx = {
  borderRadius: "14px",
  maxHeight: "88vh",
  m: 2,
  width: "calc(100% - 32px)",
  "& .MuiTypography-h6": { fontSize: "16px !important", fontWeight: 700 },
  "& .MuiTypography-body1, & .MuiTypography-body2": {
    fontSize: "14px !important",
    lineHeight: 1.6,
  },
  "& .MuiTypography-caption": { fontSize: "12px !important", lineHeight: 1.5 },
  "& .MuiChip-label": {
    fontSize: "12px !important",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
  },
  "& .MuiButton-root": {
    fontSize: "13px !important",
    minHeight: 36,
    textTransform: "none",
    fontWeight: 600,
    boxShadow: "none",
    borderRadius: "8px",
  },
  "& .MuiButton-contained:not(.Mui-disabled)": { color: "#fff !important" },
  "& .MuiButton-containedPrimary:not(.Mui-disabled)": {
    bgcolor: "#155e66",
    "&:hover": { bgcolor: "#104c53" },
  },
  "& .MuiOutlinedInput-root": { minHeight: 44, fontSize: "14px !important", height: "auto" },
  "& .MuiInputBase-input": { fontSize: "14px !important", py: "11px !important" },
  "& .MuiIconButton-root": { width: 32, height: 32 },
  "& .MuiIconButton-root .MuiSvgIcon-root": { fontSize: 18 },
};
export const reportFooterSx = { px: 2.5, py: 1.5, borderTop: 1, borderColor: "divider", gap: 0.75 };
